export enum ProjectDiscussionAddComment {
  Comment = 'PROJECTS_MODULE.DISCUSSION.discussionAddComment',
  Update = 'PROJECTS_MODULE.DISCUSSION.discussionUpdate',
  Reply = 'PROJECTS_MODULE.DISCUSSION.discussionReply',
}
